import { rgba } from 'polished';
import { IconButton } from 'shared/components/ui/icon-button';
import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

import { Trigger } from './setup-checklist-menu.style';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};

  padding: ${({ theme }) => theme.spacing(2)};

  background: ${({ theme }) => theme.palette.common.black};
  border: 1px solid ${({ theme }) => theme.palette.grey[400]};
  border-radius: ${({ theme }) => theme.spacing(4)};
  color: ${({ theme }) => theme.palette.background.default};
  &:hover ${Trigger} {
    opacity: 1;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  padding-top: ${({ theme }) => theme.spacing(1)};
  padding-left: ${({ theme }) => theme.spacing(2)};
  padding-right: ${({ theme }) => theme.spacing(2)};
`;

export const TitleBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.subtitle2)};
  color: ${({ theme }) => theme.palette.common.white};
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};

  color: ${({ theme }) => theme.palette.common.white};
`;

export const HeaderButton = styled(IconButton)`
  &:hover {
    background: ${({ theme }) => rgba(theme.palette.common.white, 0.1)};
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${({ theme }) => theme.spacing(1)};
  padding-bottom: ${({ theme }) => theme.spacing(1)};
`;
